import { hasActiveSubscription_api, getSubscriptionInfo_api, deletePendingSubscription_api, deleteSubscription_api } from './contest-subscription.service';
import { createServiceWithErrorHandling } from '../../utils/error-handling.utils';

export function useContestSubscription() {
  return createServiceWithErrorHandling({
    /**
     * Verifica si el usuario tiene una suscripción activa para el concurso
     * @param user_id - El ID del usuario
     * @param contest_id - El ID del concurso
     * @returns Promise con la respuesta que indica si tiene suscripción activa
     */
    hasActiveSubscription: async (user_id: number, contest_id: number) => {
      return await hasActiveSubscription_api(user_id, contest_id);
    },
    /**
     * Obtiene información completa de la suscripción del usuario para el concurso
     * @param user_id - El ID del usuario
     * @param contest_id - El ID del concurso
     * @returns Promise con la información completa de la suscripción
     */
    getSubscriptionInfo: async (user_id: number, contest_id: number) => {
      return await getSubscriptionInfo_api(user_id, contest_id);
    },
    /**
     * Elimina una suscripción pendiente para permitir crear una nueva
     * @param user_id - El ID del usuario
     * @param contest_id - El ID del concurso
     * @returns Promise con la respuesta que indica si se eliminó la suscripción
     */
    deletePendingSubscription: async (user_id: number, contest_id: number) => {
      return await deletePendingSubscription_api(user_id, contest_id);
    },
    /**
     * Elimina una suscripción específica por su ID (solo para administradores)
     * @param subscriptionId - El ID de la suscripción
     * @returns Promise con la respuesta que indica si se eliminó la suscripción
     */
    deleteSubscription: async (subscriptionId: number) => {
      return await deleteSubscription_api(subscriptionId);
    },
  });
}
